import strFunc from "@/lib/lyg/string";
import { useRef } from 'react';
import SectionArea from "./section";

function SectionStudyArea(props: any) {
  const myProps = {
    section_arr: [],
    study_arr: [],
    set_section_arr: (section_arr: any) => { },
    set_study_arr: (study_arr: any) => { },
    rowData:{},
    ...props
  };

  let section_arr = myProps.section_arr;
  const section_study_wrap_ref=useRef<any>(null);

  let default_section_info = {
    a_book_seq: "",
    a_seq: "",
    a_title: "",
    a_memo: "",
    a_order_num: "",
    study_arr: [],//[{row_num:0},...]
  };

  const get_section_arr_of_addon_study = () => {
    let addon_section_arr = [];
    let section_len = myProps.section_arr.length;
    let study_row_num_arr = [];
    for (let section_i = 0; section_i < section_len; section_i++) {
      let section_info = {
        ...default_section_info,
        ...myProps.section_arr[section_i]
      };
      section_info.study_arr = [];
      for (let i = 0; i < myProps.study_arr.length; i++) {
        let study_info = myProps.study_arr[i];
        if (section_info["a_seq"] == study_info["a_section_seq"]) {
          study_info["row_num"] = i;
          section_info.study_arr.push(study_info);
          study_row_num_arr.push(i);
        }
      }
      addon_section_arr.push(section_info);
    }

    //빈섹션 등록
    if (study_row_num_arr.length != myProps.study_arr.length && myProps.study_arr.length.length > 0) {
      let last_section_num = myProps.section_arr.length + 1;
      let empty_section_info: any = {
        ...default_section_info,
        a_book_seq: "",
        a_seq: "empty",
        a_title: "소속없음",
        a_order_num: last_section_num,
      };
      empty_section_info.study_arr = [];
      for (let i = 0; i < myProps.study_arr.length; i++) {
        let study_info = myProps.study_arr[i];
        if (strFunc.str_in_array(i, study_row_num_arr) == -1) {
          study_info["row_num"] = i;
          empty_section_info.study_arr.push(study_info);
          study_row_num_arr.push(i);
        }
      }
      addon_section_arr.push(empty_section_info);
    }

    return addon_section_arr;
  };

  const get_section_tag_arr = () => {
    //section_arr 만들기
    let addon_section_arr = get_section_arr_of_addon_study();

    //tags얻기
    let section_tags: any = addon_section_arr.map((item: any, idx: number) => {
      return (
        <SectionArea
          key={idx}
          rowData={myProps.rowData}
          section_info={item}
          section_row_num={idx}
          section_arr={myProps.section_arr}
          study_arr={myProps.study_arr}
        ></SectionArea>
      );
    });

    return section_tags;
  };

  return (
    <div style={{ border: "1px solid #ddd", padding: 5 }}>
      <h4 style={{ color: "#00f" }}>
        단원
      </h4>
      <div className="mt-1" ref={section_study_wrap_ref}>
        {get_section_tag_arr()}
      </div>
    </div>
  );
}
export default SectionStudyArea;